import React from 'react';
import { TextField } from '@material-ui/core';
import { Control, Controller, useWatch } from 'react-hook-form';
import { EditableQuestion, StructuredInputToggle } from '../../../../../types';

interface Props {
  control: Control<EditableQuestion>;
}

/**
 * Which unit the question opens on. Absent below two toggles: there is nothing to choose
 * between, and clients fall back to the first one anyway.
 */
const DefaultTogglePicker = ({ control }: Props) => {
  const toggles: StructuredInputToggle[] = useWatch({ control, name: 'input.toggles' }) ?? [];

  if (toggles.length < 2) return null;

  return (
    <Controller
      name="input.default_toggle"
      control={control}
      render={({ field: { onChange, ref, value, ...restField } }) => (
        <TextField
          inputRef={ref}
          {...restField}
          value={value ?? ''}
          select
          SelectProps={{ native: true }}
          inputProps={{ 'aria-label': 'Opens on' }}
          helperText="The unit a patient sees first. Defaults to the toggle at the top."
          onChange={event => onChange(event.target.value)}
        >
          <option value="">First toggle</option>
          {toggles.map(toggle => (
            <option key={toggle.id} value={toggle.id}>
              {toggle.label || toggle.id}
            </option>
          ))}
        </TextField>
      )}
    />
  );
};

export default DefaultTogglePicker;
